<template>
  <v-container fluid>
    <v-row>----------------------</v-row>
    <v-row>| Available Commands |</v-row>
    <v-row>----------------------</v-row>
    <v-row v-for="(datum, index) in command.data" :key="index">
      <v-row class="commandRow">
        <v-col class="command">
          {{ datum.command }}
        </v-col>
        <v-col>
          {{ datum.description }}
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "commandPreview",
  props: ["command"]
};
</script>

<style scoped>
.container {
  padding: 0;
  padding-bottom: 5px !important;
}

.row {
  justify-content: center;
  margin: 0;
  margin-right: 8px;
}

.historyText {
  white-space: pre-line;
  padding-left: 10px;
  position: relative;
  top: -1px;
  max-width: 90%;
  word-break: break-word;
}

.col {
  border: 1px dashed white;
  text-align: center;
  padding: 5px 0;
}

.command {
  color: #009b64ba;
}
</style>
